import { render, staticRenderFns } from "./LsCustomerDetails.vue?vue&type=template&id=e195b468&scoped=true&"
import script from "./LsCustomerDetails.vue?vue&type=script&lang=js&"
export * from "./LsCustomerDetails.vue?vue&type=script&lang=js&"
import style0 from "./LsCustomerDetails.vue?vue&type=style&index=0&id=e195b468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e195b468",
  null
  
)

export default component.exports